// PDF URL mapping - buraya istediğiniz PDF'leri ekleyebilirsiniz
export const PDF_MAP: Record<string, { url: string; title: string }> = {
  'cv': {
    url: '/gafur-apil-cv.pdf',
    title: 'Gafur Apil - CV'
  },
  'bachelorarbeit': {
    url: '/gafur_apil_bachelorarbeit.pdf',
    title: 'Gafur Apil - Bachelorarbeit'
  },
  'psm1': {
    url: '/psm1.pdf',
    title: 'Professional Scrum Master (PSM-1)'
  },
};
